import React, { useEffect } from 'react';
import EventHandler from '../utils/EventHandler'
import Slider from '../utils/Slider'
import SVG from './SVG.jsx';

export default function SizeGuide(props) {
  const ref = React.createRef();
  const ev = new EventHandler();

  useEffect(() => {
    if (ref.current) { 
      ref.current.querySelectorAll('[data-accordion]').forEach(e => {
        ev.register(e, 'click', (e) => {e.currentTarget.classList.toggle('expanded')})
      });
      const carousel = ref.current.querySelector('.as-seen-on-carousel');
      if (carousel) {
        new Slider(carousel, {
          wrapAround: true,
        });
      }
      const swapTrigger = ref.current.querySelector('#view-intl-sizing') || ref.current.querySelector('#view-us-sizing');
      var btntrigger=ref.current.querySelector(".sizing_det-trigger");
      if(btntrigger){
          btntrigger.addEventListener("click", function(){
            var view_Html=document.querySelector(".Dev_main_sizing-details");
  
            view_Html.classList.toggle("active");
            if (view_Html.classList.contains("active")){
              btntrigger.textContent="Hide measurement guide";
              view_Html.style.display="block";
              view_Html.style.maxHeight = view_Html.scrollHeight + "px";  
            }
            else {
             
              view_Html.style.maxHeight = null;
              btntrigger.textContent="Show measurement guide";
              setTimeout(function(){
                view_Html.style.display="none";
              },200);
             
             
            }
          });
        }

      const setupSwitcherEventListeners = () => {
        const btnSwitchers = ref.current.querySelectorAll(".switchers_button .switcher");
        const switcherDescriptions = ref.current.querySelectorAll(".switchers_description .switcher_description");
        const sizeCharts = ref.current.querySelectorAll(".Dev_measurement-object-main .Dev_table-obj");
        if (btnSwitchers.length) {
          btnSwitchers.forEach((btnSwitcher) => {
            btnSwitcher.addEventListener('click', () => {
              let btnType = btnSwitcher.getAttribute('type');

              btnSwitchers.forEach((btnSwitch) => {
                btnSwitch.classList.remove('active')
              });
              switcherDescriptions.forEach((switcherDes) => {
                switcherDes.classList.remove('active');
                if ( switcherDes.getAttribute('type') == btnType ) {
                  switcherDes.classList.add('active');
                }
              });
              sizeCharts.forEach((sizeChart) => {
                sizeChart.classList.remove('active');
                if ( sizeChart.getAttribute('type') == btnType ) {
                  sizeChart.classList.add('active');
                }
              });

              btnSwitcher.classList.add('active');

              console.log("btnSwitcher clicked: ", btnSwitcher + btnType);

              // Your logic for switcher click event
            });
          });
        }
      };
      
      setupSwitcherEventListeners();
      

      if (swapTrigger) {
        if (props.open) {
         
          if (swapEv) {
            ev.unregister(swapEv);
          }
          swapEv = ev.register(swapTrigger, 'click', props._swapSizeGuide);
        } else {
          ev.unregister(swapEv);
        }
      }
      const toggleMeasurement = ref.current.querySelector('#toggle-measurements-2');
      
      if (toggleMeasurement) {
        if (props.open) {
         
          if (toggleEv) {
            ev.unregister(toggleEv);
          }
          toggleEv = ev.register(toggleMeasurement, 'click', props._toggleMeasurement);
        } else {
          ev.unregister(toggleEv);
        }
      }
    }
  }, [ref.current]);

  return <div ref={ref} className="rte">
    {props.children}
  </div>
}